import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class TealiumService {
  
  constructor() { }

  public init(account: string, profile: string, env: string): void {
    (window as any).utag_cfg_ovrd = { noview: true };
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://tags.tiqcdn.com/utag/${account}/${profile}/${env}/utag.js`;
    document.head.appendChild(script);
  }

  public trackView(data: any): void {
    if ((window as any).utag) {
      (window as any).utag.view(data);
    }
  }

  public trackEvent(data: any): void {
    if ((window as any).utag) {
      (window as any).utag.link(data);
    }
  }
}